import { normalizeVariantId } from './toggleVariantAssignment';

export function groupAssetsByVariant(channelAssignments = {}, variantIds = []) {
  const grouped = variantIds.reduce((acc, variantId) => {
    acc[normalizeVariantId(variantId)] = [];
    return acc;
  }, {});

  Object.entries(channelAssignments).forEach(([assetId, assignedVariantIds]) => {
    (assignedVariantIds || []).forEach((variantId) => {
      const key = normalizeVariantId(variantId);
      if (!grouped[key]) return;
      grouped[key].push(String(assetId));
    });
  });

  return grouped;
}

export function getUnassignedAssets(allAssets = [], channelAssignments = {}) {
  const assignedAssetIds = new Set(Object.keys(channelAssignments).map(String));

  return allAssets.filter(({ _id }) => !assignedAssetIds.has(String(_id)));
}

export function assignAssetToVariant({
  assignments = {},
  assetId,
  variantId,
}) {
  const normalizedAssetId = String(assetId);
  const normalizedVariantId = normalizeVariantId(variantId);
  const next = { ...assignments };

  Object.entries(next).forEach(([currentAssetId, assignedVariantIds]) => {
    if (currentAssetId === normalizedAssetId) return;

    const filteredVariantIds = (assignedVariantIds || [])
      .filter((id) => normalizeVariantId(id) !== normalizedVariantId);

    if (filteredVariantIds.length) {
      next[currentAssetId] = filteredVariantIds;
    } else {
      delete next[currentAssetId];
    }
  });

  const existingVariantIds = (next[normalizedAssetId] || [])
    .map((id) => normalizeVariantId(id));

  if (!existingVariantIds.includes(normalizedVariantId)) {
    existingVariantIds.push(normalizedVariantId);
  }

  next[normalizedAssetId] = existingVariantIds;
  return next;
}

export function unassignAssetFromVariant({ assignments = {}, assetId, variantId }) {
  const normalizedAssetId = String(assetId);
  const normalizedVariantId = normalizeVariantId(variantId);
  const next = { ...assignments };
  const remainingVariantIds = (next[normalizedAssetId] || [])
    .map((id) => normalizeVariantId(id))
    .filter((id) => id !== normalizedVariantId);

  if (remainingVariantIds.length) {
    next[normalizedAssetId] = remainingVariantIds;
  } else {
    delete next[normalizedAssetId];
  }

  return next;
}

export function unassignAsset({ assignments = {}, assetId }) {
  const next = { ...assignments };
  delete next[String(assetId)];
  return next;
}

export function getAssignedAssetsForVariant(allAssets = [], assignedAssetIds = []) {
  const assignedSet = new Set(assignedAssetIds.map(String));

  return allAssets.filter(({ _id }) => assignedSet.has(String(_id)));
}

export function getDefaultExpandedVariantIds(variantOptions = []) {
  const firstVariantId = variantOptions[0]?.id;

  if (!firstVariantId) {
    return new Set();
  }

  return new Set([normalizeVariantId(firstVariantId)]);
}

export function toggleExpandedVariantIds(expandedIds, variantId) {
  const normalizedVariantId = normalizeVariantId(variantId);
  const next = new Set(expandedIds);

  if (next.has(normalizedVariantId)) {
    next.delete(normalizedVariantId);
    return next;
  }

  next.add(normalizedVariantId);
  return next;
}
